import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { getAdminSession } from "../controller/api";

const RequireAdmin = ({ children }) => {
  const navigate = useNavigate();
  const [status, setStatus] = useState("checking"); // checking | authed

  useEffect(() => {
    getAdminSession()
      .then(() => setStatus("authed"))
      .catch(() => navigate("/admin/login"));
  }, [navigate]);

  if (status === "checking") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--paper)] text-[var(--muted)] text-sm">
        Checking session…
      </div>
    );
  }

  return children;
};

export default RequireAdmin;
